import React from "react";
import type { TenantStatus } from "../types";

const LABELS: Record<TenantStatus, string> = {
  draft: "Draft",
  awaiting_setup: "Awaiting setup",
  ready_for_test: "Ready for test",
  ready_for_production: "Ready to launch",
  active: "Active",
  suspended: "Suspended",
  offboarding: "Offboarding"
};

const CLASSES: Record<TenantStatus, string> = {
  draft: "",
  awaiting_setup: "warn",
  ready_for_test: "info",
  ready_for_production: "info",
  active: "success",
  suspended: "danger",
  offboarding: "danger"
};

export function StatusPill({ status }: { status: TenantStatus }) {
  return <span className={`pill ${CLASSES[status]}`}>{LABELS[status]}</span>;
}
